
import { Component, Vue, Prop } from "vue-property-decorator";

import UserWorkplace from "@/models/user/workplace";

@Component
export default class CUecWorkplace extends Vue {
  @Prop({ required: true }) workplace!: UserWorkplace;
}
